import { useEffect, Fragment, useContext, useState, JSX } from "react";
import { /*useHistory,*/ useParams } from "react-router-dom";
import { Flyout, FlyoutFooter } from "@app/shared/Flyouts";
import FlyoutContextProvider, { FlyoutContext } from "@app/shared/Flyouts/FlyoutContext";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { ImportAddStepsGroup } from "@app/provider-network-imports/components/ImportAddStepsGroup";
import { useImportAddSteps, useImportConfig, useVersions } from "@app/provider-network-imports/hooks";
import { License } from "@app/provider-network-imports/models";

const WrappedImportAddStepsSidePanel = (): JSX.Element => {
  const { versionId } = useParams<{ networkId?: string, versionId?: string }>();
  const flyoutContext = useContext(FlyoutContext);
  const {
    clearSelected,
    displayAddSteps,
    isAddStepsLoading,
    licenseFilterChanged,
    licenses,
    loadAvailableSteps,
    loadLicenseTypes,
    getAvailableGroups,
    selectedGroups,
    selectedLicense,
  } = useImportAddSteps();
  const { addGroups } = useImportConfig();
  // const history = useHistory();
  const { isActivated } = useVersions();
  // const importPageRouter = new ImportPageRouter();
  const [flyoutHasOpened, setFlyoutHasOpened] = useState(false || displayAddSteps);

  useEffect(() => {
    loadAvailableSteps();
    loadLicenseTypes();
  }, []);

  useEffect(() => {
    flyoutContext.setIsFlyoutVisible(displayAddSteps);

    if (displayAddSteps) {
      setFlyoutHasOpened(displayAddSteps);
    } else if (flyoutHasOpened) {
      // importPageRouter.closeAddStepsRoute(history);
    }
  }, [displayAddSteps]);

  const isActive = isActivated(+versionId);
  const addStepsGroups = getAvailableGroups().map((group) => {
    return (<ImportAddStepsGroup key={group} group={group} />);
  });

  const addSteps = () => {
    const license = selectedLicense === License.Any ? null : selectedLicense;
    addGroups(selectedGroups(), license);
    clearSelected();
    // importPageRouter.closeAddStepsRoute(history);
  };

  const sidePanel = isAddStepsLoading ? null : (
    <Flyout
      content={{
        body: (<div className="d-flex flex-column justify-content-between">
          <span>Select the license types you want enabled by default</span>
          <QESSelect label="License" hideLabel={true} testId="import-add-steps__license-select" className="form-control" onChange={(e) => licenseFilterChanged(e.currentTarget.value as License)} value={selectedLicense}>
            <option value={License.Any}>All</option>
            {
              licenses.map((license) => {
                return (
                  <option key={license.license} value={license.license}>
                    {license.name}
                  </option>
                );
              })
            }
          </QESSelect>
          <div className="pt-2 pb-2">
            {addStepsGroups}
          </div>
          <FlyoutFooter
            submitButton={<QESButton qesTestId="import-add-steps-side-panel_add-steps" qesType="primary" className="mt-1 mr5" disabled={selectedGroups().length === 0} onClick={addSteps}>Add Steps</QESButton>}
          />
        </div>),
        title: "Add Import Steps",
      }}
      size="40"
    />
  );
  return (
    <Fragment>
      <QESButton qesTestId="import-add-steps-side-panel_add-standardization-group" qesType="secondary" disabled={isActive} onClick={() => /*importPageRouter.openAddStepsRoute(history)*/ null}>
        <i className="fa fa-plus me-1" /> Add Standardization Group
      </QESButton>
      {sidePanel}
    </Fragment>
  );
};

export const ImportAddStepsSidePanel = (
  <FlyoutContextProvider>
    <WrappedImportAddStepsSidePanel />
  </FlyoutContextProvider>
);
